// CSS
import '../css/styles.scss';


// JQuery
import $ from 'jquery';
window.jQuery = $;
window.$ = $;

// Vendor
import 'slick-carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/util';

// JS
import { Cursor } from "./components/cursor";
import { InViewport } from "./components/inviewport";
import { CookieBanner } from "./components/cookie-banner";
import { Parallax } from "./components/parallax";
import { Carousel } from "./components/carousel";
import { CycleText } from "./components/cycle-text";
import { Form } from "./components/form";
import { Navigation } from "./components/navigation";
import { Type } from "./components/type";
import { Video } from "./components/video";
import { Filtering } from "./components/filtering";
import { News } from "./components/news";


$(document).ready(function() {
  Cursor();
  InViewport();
  CookieBanner();
  Parallax();
  Carousel();
  CycleText();
  Form();
  Navigation();
  Video();
  Type();
  Filtering();
  News();
});